import React from 'react';
import styled from 'styled-components';

import { Button } from 'src/presentation/components/agent_desktop_components';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import { StepWizardActionContainer } from './shared/elements';
import { StepWizardFieldWithBorder } from 'src/presentation/components/pages/email/components/StepWizardLayout';

import LinkOutStrokeV2 from '@ad-scripts/presentation/components/common/icons/stroke/link-out-v2-stroke';

const PhoneSmsVerificationPortOrForward = ({ closeModal }: { closeModal }) => {
  return (
    <>
      <StepWizardFieldWithBorder>
        <>
          <H3 data-aid="wizard-title">A2P 10DLC Registration & Toll-Free Verification</H3>
          <StyledDescription>
            To initiate the required A2P registration or Toll-Free verification process for newly purchased US and CA
            phone numbers,
            <br /> select the appropriate form below based on the type of number you are configuring.
          </StyledDescription>
          <StyledExternalLink
            className="external-link"
            data-aid="learnAbout"
            icon={<StyledLinkOutStrokeV2 />}
            label={'Twilio Business Registration "A2P 10DLC"'}
            showIcon={true}
            to="https://www.surveymonkey.com/r/Twilio_A2P_10DLC_Registration"
          />
          <StyledDescription>
            A2P 10DLC numbers (e.g., +1 NNN XXX-XXXX where NNN is a local area code) must be registered before use for
            messaging.
            <br /> A2P 10DLC numbers are governed by the FCC and CTIA and require businesses to follow guidelines and
            regulations such
            <br /> as the TCPA in the US.
          </StyledDescription>

          <StyledExternalLink
            className="external-link"
            data-aid="learnAbout"
            icon={<StyledLinkOutStrokeV2 />}
            label="Toll-Free Number Messaging Verification"
            showIcon={true}
            to="https://www.surveymonkey.com/r/Twilio-Toll-Free-Registration"
          />
          <StyledDescription>
            Toll-Free numbers (e.g., +1 8NN XXX-XXXX where NN is two repeated digits like +1 855) in the US and CA must
            be verified to send messages and ensure delivery by reducing network-level filtering of messages. Unverified
            Toll-Free phone numbers have lower volume limits and a higher chance of being tagged as spam by networks.
          </StyledDescription>
        </>
      </StepWizardFieldWithBorder>
      <StepWizardActionContainer>
        <Button data-aid="editor-done" type={Button.Types.PRIMARY} onClick={closeModal}>
          Done
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

const StyledLinkOutStrokeV2 = styled(LinkOutStrokeV2)`
  fill: ${p => p.theme.colors.green400};
`;

const StyledExternalLink = styled(ExternalLink)`
  font-weight: 700;

  svg {
    position: relative;
    top: 3px;
  }
`;

const StyledDescription = styled.p`
  line-height: 20px;
  margin-bottom: 20px;
`;

export default PhoneSmsVerificationPortOrForward;
